// Do NOT add "use client" to this file
import React, { PropsWithChildren } from "react";

export const ProductTileContainer: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="relative flex flex-col" data-test-id="product-tile">
    {children}
  </div>
);
